import { axios } from "@Root/API";

export const getStudentsWithFinancialSupport = params => {
  return axios.get("finances", { params });
};
